module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_2-0b74d74f32e345e72045481eaf89f511.webp";